export default "__VITE_ASSET__C1jgO3Tm__"